// src/design/breadcrumbs/@/controller/index.tsx
function e(e, t, n, r) {
	return e >= Math.max(1, n) && e < t - Math.max(1, r);
}
function t(t, n, r, i) {
	if (!i || t <= n + r + 1) return null;
	for (let i = 0; i < t; i++) if (e(i, t, n, r)) return i;
	return null;
}
export { t as getFirstCollapsedIdx, e as isItemCollapsed };

//# sourceMappingURL=index.js.map